import css from 'styled-jsx/css'
export const styles = css`
  .player-label-bgm {
    display: inline-block;
    position: relative;
    border: 2px solid #008cdb;
    border-radius: 30px;
    background: transparent;
    height: 30px;
    z-index: 0;
    width: 170px;
  }
  .player-label-bgm:before {
    position: absolute;
    content: '';
    top: 2px;
    left: 5px;
    background-image: url(${process.env.IMG_SERVER}/icon/music.png);
    background-repeat: no-repeat;
    background-size: 20px 20px;
    height: 20px;
    width: 20px;
    z-index: -1;
  }
  .player-select-bgm {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    border-radius: 30px;
    background-color: transparent;
    box-shadow: none;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    z-index: 1;
    line-height: 30px;
    width: 170px;
    padding-left: 25px;
    text-align: left;
  }
  .player-select-bgm:focus {
    outline: 0;
  }
  .player-select-bgm ::-ms-expand {
    display: none;
  }
`
